import PropTypes from 'prop-types';
import OkDialog from '../shared/dialog/OkDialog';
import dialogCss from '../shared/dialog/dialog.module.scss';
import { okDialogStyles } from '../shared/dialog/styles';

const successHeading = "You did it. You're Premium.";

const headingContent = (
  <div className={dialogCss.heading}>{successHeading}</div>
);

const PaymentSuccessDialog = ({
  shouldShow,
  handleClose,
  content,
  dataTestId,
  altHeading,
}) => (
  <OkDialog
    shouldShow={shouldShow}
    handleClose={handleClose}
    content={content}
    heading={altHeading || headingContent}
    dataTestId={dataTestId}
    dialogContentStyle={okDialogStyles.content}
    bodyStyle={okDialogStyles.body}
  />
);

PaymentSuccessDialog.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  altHeading: PropTypes.object,
};

export default PaymentSuccessDialog;
